import DatabaseModel from './DatabaseModel.js';

var TarifaContenido = Object.create(DatabaseModel);
TarifaContenido.model = 'tarifa-contenidos';
TarifaContenido.modelFront = 'tarifa-contenidos';

TarifaContenido.listar = function(params) {
    var self = this;
    params = params || {};
    var qs = [];
    if (params.modulo) qs.push('modulo=' + encodeURIComponent(params.modulo));
    if (params.tipo) qs.push('tipo=' + encodeURIComponent(params.tipo));
    var url = self.server_movilidad + self.prefix + self.model + '/?' + qs.join('&');
    var request = { url: url, method: 'GET', data: {} };
    return self.sendRequest(request, true);
};

TarifaContenido.crear = function(data) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/',
        method: 'POST',
        data: data
    };
    return self.sendRequest(request, false);
};

TarifaContenido.actualizar = function(id, data) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/' + id + '/',
        method: 'PUT',
        data: data
    };
    return self.sendRequest(request, false);
};

TarifaContenido.eliminar = function(id) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/' + id + '/',
        method: 'DELETE',
        data: {}
    };
    return self.sendRequest(request, false);
};

export default TarifaContenido;
